import React, { useState } from 'react';
import NewUserInfo from '../../Main/NewUserInfo';
import { CircularProgress, Dialog, Grid, makeStyles, Avatar } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import styles from '../../Main/main.styles';
import { isEmpty } from 'lodash';
import AddCaregivers from '../Dashboard/components/AddCaregivers.jsx';
import Button from '../../components/Button';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import AddIcon from '@mui/icons-material/Add';
import './caregivers.css';
import GirlImage from '../../images/girl.png';
import BoyImage from '../../images/boy.png';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '../../components/Snackbar';
import SelectInput from '../../components/SelectInput.jsx';
import { useQuery, useMutation } from 'react-query';
import { changeRelationStatus, deleteCaregivers, getCaregivers, getRecipientCaregivers } from '../../utils/api';
import RecipientsSelector from '../Components/RecipientsSelector';
import { toast } from 'react-toastify';
import { careUserType, CARE_CIRCLE_RELATION_STATUS, ICON_BUTTON_TYPE } from '../../constants';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IconButton from '../../components/IconButton.jsx';

const useStyles = makeStyles(styles);

const relations = [
  'Grand Father',
  'Grand Mother',
  'Father',
  'Mother',
  'Sister',
  'Brother',
  'Spouse',
  'Son',
  'Daughter',
  'Friend',
  'Professional Caregiver',
];

const Caregivers = () => {
  let tab = '1';
  const classes = useStyles();
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const [addCaregiverModal, setAddCaregiverModal] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({ state: false, name: null, userId: null });
  const [openSnack, setOpenSnack] = useState(false);

  const {
    data: caregivers,
    isLoading,
    refetch,
  } = useQuery(
    ['getCaregivers', 'getRecipientCaregivers', selectedRecipient],
    () =>
      isEmpty(selectedRecipient)
        ? getCaregivers({ userId: user?._id || user?.id, filter: 'all' })
        : getRecipientCaregivers({ userId: user?._id || user?.id, recipientId: selectedRecipient, filter: 'all' }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const deleteMeds = useMutation(deleteCaregivers, {
    onSuccess: (data) => {
      setConfirmDeleteModal({ state: false, name: null, userId: null });
      setOpenSnack(true);
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDeleteCaregivers = (caregivers) => {
    deleteMeds.mutate({ userId: user?._id, caregivers });
  };

  const handleOpenDeleteModal = ({ state, name, userId }) => {
    if (!isEmpty(selectedRecipient)) {
      toast.error('Cannot delete caregivers!');
    } else {
      setConfirmDeleteModal({ state, name, userId });
    }
  };

  const changeStatus = useMutation(changeRelationStatus, {
    onSuccess: (data) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleChangeStatus = (id, status) => {
    changeStatus.mutate({ userId: user?._id, relationId: id, status });
  };

  return (
    <>
      <NewUserInfo />
      <div className="flex-column-a" style={{ left: width > 850 ? '15%' : '0%' }}>
        <RecipientsSelector />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          direction={width > 550 ? 'row' : 'column'}
          style={{ marginBottom: '20px' }}
        >
          <h1>Caregivers</h1>
          <Button text="Invite Caregiver" onClick={() => setAddCaregiverModal(true)} startIcon={<AddIcon />} />
        </Grid>

        {isLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '40vh',
              width: '100%',
            }}
          >
            <CircularProgress style={{ color: '#26786a' }} size={100} />
          </div>
        )}
        {!isLoading &&
          (isEmpty(caregivers?.data) ? (
            <Grid container justifyContent="center" className="no-caregiver-div">
              <h3>No caregivers found!</h3>
            </Grid>
          ) : (
            caregivers?.data.map((item, idx) => (
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                className="caregivers-div"
                key={idx}
                style={{ marginTop: '20px' }}
              >
                <Grid sm={5} lg={5} md={5} xs={12} container>
                  <Avatar
                    src={
                      !isEmpty(item?.caregiverId?.userInfo?.imageUrl)
                        ? item?.caregiverId?.userInfo?.imageUrl
                        : item?.caregiverId?.userInfo?.gender === 'female'
                          ? GirlImage
                          : BoyImage
                    }
                    alt="image"
                    style={{
                      height: '100px',
                      width: '100px',
                    }}
                  />
                  <div style={{ marginLeft: '20px' }}>
                    <h2>
                      {item?.caregiverId?.userInfo?.firstName} {item?.caregiverId?.userInfo?.lastName || ''}
                    </h2>
                    <span className="cg-phone-email">{item?.caregiverId?.username || ''}</span>{' '}
                    <span className="cg-phone-email">{item?.caregiverId?.email}</span>
                  </div>
                </Grid>
                {item?.status === CARE_CIRCLE_RELATION_STATUS.pending && item?.addedBy === careUserType.cargiver ? (
                  <>
                    <Grid sm={2} lg={2} md={2} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                      <CheckCircleIcon
                        className="delete-icon"
                        style={{ color: 'green' }}
                        onClick={() => handleChangeStatus(item?._id, CARE_CIRCLE_RELATION_STATUS.active)}
                      />
                      <IconButton
                        type={ICON_BUTTON_TYPE.delete}
                        style={{ marginLeft: '20px' }}
                        onClick={() => handleChangeStatus(item?._id, CARE_CIRCLE_RELATION_STATUS.cancelled)}
                      />
                    </Grid>
                  </>
                ) : item?.status === CARE_CIRCLE_RELATION_STATUS.pending &&
                  item?.addedBy === careUserType.careRecipient ? (
                  <Grid sm={12} lg={6} md={6} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Grid className="health-box">
                      <small>Invited</small>
                    </Grid>
                  </Grid>
                ) : (
                  <>
                    <Grid
                      sm={4}
                      lg={4}
                      md={4}
                      xs={12}
                      justifyContent="center"
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {/* <div style={{ width: '100%' }}>
                        <SelectInput options={relations} value={item?.relation} onChange={() => {}} fullWidth />
                      </div> */}
                    </Grid>
                    <Grid sm={2} lg={2} md={2} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                      <IconButton
                        type={ICON_BUTTON_TYPE.delete}
                        onClick={() =>
                          handleOpenDeleteModal({
                            state: true,
                            name: item?.caregiverId?.userInfo?.firstName,
                            userId: item?.caregiverId?._id,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            ))
          ))}
      </div>
      <Dialog className={classes.modal} open={addCaregiverModal} maxWidth={false}>
        <AddCaregivers user={user} refresh={refetch} closeModal={() => setAddCaregiverModal(false)} />
      </Dialog>
      <Dialog className={classes.modal} open={confirmDeleteModal.state} maxWidth={false}>
        <div className="delete-caregiver-modal">
          <Grid container justifyContent="space-between">
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Delete Caregiver</span>
            <CloseIcon onClick={() => setConfirmDeleteModal({ state: false, name: null, userId: null })} />
          </Grid>
          <Grid container style={{ marginBlock: '30px' }}>
            <span>Are you sure you want to remove {confirmDeleteModal.name} from your Care team?</span>
          </Grid>
          <div style={{ marginBlock: '20px', borderBottom: '0.5px solid grey' }} />
          <Grid container item direction="row" justifyContent="space-between" alignItems="center">
            <Grid item style={{ marginRight: '10px' }}>
              <Button
                bg="light"
                text="Cancel"
                onClick={() => setConfirmDeleteModal({ state: false, name: null, userId: null })}
                style={{ borderRadius: '50px' }}
              />
            </Grid>
            <Grid item>
              <Button
                text="Delete"
                onClick={() => handleDeleteCaregivers([confirmDeleteModal.userId])}
                style={{
                  borderRadius: '50px',
                  background: '#ff4747',
                  '&:hover': {
                    background: '#ed5c5c',
                    boxShadow: 'none',
                  },
                }}
              />
            </Grid>
          </Grid>
        </div>
      </Dialog>
      <EmergencyButton />
      <Snackbar
        open={openSnack}
        handleClose={() => setOpenSnack(false)}
        message="Caregiver has delete from care team"
      />
    </>
  );
};

export default Caregivers;
